import React, { Component } from 'react';
import * as $ from 'jquery';
import { translate } from 'react-i18next';
import { compose } from 'recompose';
import { withRouter } from 'react-router-dom';

class InterestedDialog extends Component {

  renderService = (interested, index) => {
    const { t } = this.props;

    return(
      <div key={index}>
        <table>
          <tbody>
            <tr>
              <td><img className="profile-picture" alt={t('dashboard.navbar.img_user')} src={interested.picture} />&emsp;</td>
              <td>
                <strong>{interested.name}</strong>&emsp;
                {interested.member_id && <span className="text-primary">{t('dashboard.events.is_member')}</span>}
                <br />
                {interested.job_title} {interested.company && t('dashboard.events.label_from')} <strong>{interested.company}</strong>
              </td>
            </tr>
          </tbody>
        </table>
        <br />
      </div>
    );
  }

  render() {
    const { t } = this.props;
    const event = JSON.parse(this.props.location.state.event);
    const interested_number = event.interested.length;
    
    return(
      <div>
        <div className="modal fade" id="modalInterested" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <h4 className="text-primary">
                  {interested_number==1 && interested_number+' '+t('dashboard.events.one_interested')}
                  {interested_number>1 && interested_number+' '+t('dashboard.events.many_interested')}
                </h4>
                <div>
                  {event.interested.map(
                      (_, index) => this.renderService(event.interested[index], index)
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default compose(
  translate('common'),
  withRouter
)(InterestedDialog);



// WEBPACK FOOTER //
// ./src/dashboard/events/InterestedDialog.js